var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,23.403V23.39V10.389L11.88,10.3h-0.01L9.14,8.28C7.47,7.04,5.09,7.1,3.61,8.56C2.62,9.54,2,10.9,2,12.41v3.602 L12,23.403z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38,23.39v0.013l10-7.391V12.41c0-1.49-0.6-2.85-1.58-3.83c-1.46-1.457-3.765-1.628-5.424-0.403L38.12,10.3L38,10.389V23.39 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24.868l10.406,7.692c0.353,0.261,0.836,0.261,1.189,0L36,24.868V11.867L25,20l-11-8.133V24.868z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38,25.889V41c0,0.552,0.448,1,1,1h6.5c1.381,0,2.5-1.119,2.5-2.5V18.497L38,25.889z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,25.889L2,18.497V39.5C2,40.881,3.119,42,4.5,42H11c0.552,0,1-0.448,1-1V25.889z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGmail);
export default __webpack_public_path__ + "static/media/LogoGmail.5ed1cb28b4a537a1556add230062377c.svg";
export { ForwardRef as ReactComponent };